export enum IpfProvider {
    TRUSTGRO = 'trustgro-e1de-4920-89b2-a317f7628c4a',
    "MORIENTAL-BANK" = 'MORIENTAL-BANK'
}